function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M5.25 6H11.25M5.25 9H8.25",
  stroke: "#1B1C1C",
  strokeWidth: 1.125,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M1.5 7.5C1.5 5.3998 1.5 4.3497 1.90873 3.54754C2.26825 2.84193 2.84193 2.26825 3.54754 1.90873C4.3497 1.5 5.3998 1.5 7.5 1.5H10.5C12.6002 1.5 13.6503 1.5 14.4525 1.90873C15.1581 2.26825 15.7317 2.84193 16.0913 3.54754C16.5 4.3497 16.5 5.3998 16.5 7.5V14.3781C16.5 15.1477 16.5 15.5325 16.3779 15.7727C16.1731 16.1757 15.747 16.417 15.296 16.3853C15.0272 16.3663 14.6973 16.1684 14.0374 15.7724C13.6437 15.5362 13.4469 15.4182 13.2407 15.326C12.8979 15.1729 12.5342 15.0722 12.1615 15.0271C11.9372 15 11.7077 15 11.2487 15H7.5C5.3998 15 4.3497 15 3.54754 14.5913C2.84193 14.2317 2.26825 13.6581 1.90873 12.9525C1.5 12.1503 1.5 11.1002 1.5 9V7.5Z",
  stroke: "#54606B",
  strokeWidth: 1.125,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgIcCommentTextHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCommentTextHome);
export default __webpack_public_path__ + "static/media/ic_comment-text_home.ec38ef77.svg";
export { ForwardRef as ReactComponent };